import emailValidator from '../../utils/Validate';

export interface AddPatientValidationOptions {
  pharmacyClaimsEnabled?: boolean;
}

export const addPatientGurantorValidationWithHookForm = (
  values: any,
  options?: AddPatientValidationOptions
): any => {
  const pharmacyClaimsEnabled = options?.pharmacyClaimsEnabled === true;
  const errors: any = {
    first_name: '',
    last_name: '',
    account_number: '',
    phone_1: ''
  };
  if (!values.first_name || !values.first_name.replace(/\s/g, '').length) {
    errors.first_name = 'VALIDATORS.GUARANTOR_FIRST_NAME';
  }
  if (!values.last_name || !values.last_name.replace(/\s/g, '').length) {
    errors.last_name = 'VALIDATORS.GUARANTOR_LAST_NAME';
  }
  // if (
  //   !values.account_number ||
  //   !values.account_number.replace(/\s/g, '').length
  // ) {
  //   errors.account_number = 'VALIDATORS.GUARANTOR_ACCOUNT_NUMBER';
  // }
  if (!values.phone_1 || !values.phone_1.replace(/\s/g, '').length) {
    errors.phone_1 = 'VALIDATORS.GUARANTOR_PHONE';
  }
  Object.keys(values)
    .filter((key: string) => key.includes('patient'))
    .map((key: any) => {
      if (
        key.includes('first_name') &&
        !values[key] &&
        !values[key]?.replace(/\s/g, '').length
      ) {
        errors[key] = 'VALIDATORS.PATIENT_FIRST_NAME';
      } else if (
        key.includes('last_name') &&
        !values[key] &&
        !values[key]?.replace(/\s/g, '').length
      ) {
        errors[key] = 'VALIDATORS.PATIENT_LAST_NAME';
      } else if (key.includes('email')) {
        // Email is optional; validate format only when provided.
        if (values[key] && String(values[key]).replace(/\s/g, '').length) {
          if (!emailValidator(values[key])) {
            errors[key] = 'VALIDATORS.INVALID_EMAIL';
          }
        }
      } else if (key.includes('dob')) {
        if (!values[key]) {
          errors[key] = 'VALIDATORS.PATIENT_DOB';
        } else if (values[key]._isAMomentObject && !values[key]._isValid) {
          errors[key] = 'VALIDATORS.INVALID_DATE';
        } else if (values[key]._isAMomentObject && values[key]._i) {
          const today = new Date();
          const dob = new Date(values[key]._i);
          if (dob > today) {
            errors[key] = 'VALIDATORS.DOB_FUTURE_DATE_ERROR';
          }
        }
      } else if (
        key.includes('phone') &&
        !values[key] &&
        !values[key]?.replace(/\s/g, '').length
      ) {
        errors[key] = 'VALIDATORS.PHONE';
      } else if (pharmacyClaimsEnabled) {
        if (key.includes('patient_zip_code')) {
          if (!values[key] || !String(values[key]).replace(/\s/g, '').length) {
            errors[key] = 'VALIDATORS.ZIP_POSTAL_CODE';
          }
        } else if (
          key.includes('patient_address_line_1') &&
          (!values[key] || !String(values[key]).replace(/\s/g, '').length)
        ) {
          errors[key] = 'VALIDATORS.ADDRESS_LINE';
        } else if (
          key.includes('patient_city') &&
          (!values[key] || !String(values[key]).replace(/\s/g, '').length)
        ) {
          errors[key] = 'VALIDATORS.CITY';
        } else if (
          key.includes('patient_state') &&
          (!values[key] || !String(values[key]).replace(/\s/g, '').length)
        ) {
          errors[key] = 'VALIDATORS.STATE';
        }
      }
    });
  for (const key of Object.keys(errors)) {
    if (errors[key]) {
      return errors;
    }
  }
  return {};
};

export const addPatientRowAndPayValidationWithHookForm = (values: any): any => {
  const errors: any = {
    first_name: '',
    last_name: '',
    account_number: '',
    phone_1: ''
  };
  if (!values.first_name || !values.first_name.replace(/\s/g, '').length) {
    errors.first_name = 'VALIDATORS.GUARANTOR_FIRST_NAME';
  }
  if (!values.last_name || !values.last_name.replace(/\s/g, '').length) {
    errors.last_name = 'VALIDATORS.GUARANTOR_LAST_NAME';
  }
  // if (
  //   !values.account_number ||
  //   !values.account_number.replace(/\s/g, '').length
  // ) {
  //   errors.account_number = 'VALIDATORS.GUARANTOR_ACCOUNT_NUMBER';
  // }
  if (!values.phone_1 || !values.phone_1.replace(/\s/g, '').length) {
    errors.phone_1 = 'VALIDATORS.GUARANTOR_PHONE';
  }
  Object.keys(values)
    .filter((key: string) => key.includes('patient'))
    .map(key => {
      if (
        key.includes('first_name') &&
        !values[key] &&
        !values[key]?.replace(/\s/g, '').length
      ) {
        errors[key] = 'VALIDATORS.PATIENT_FIRST_NAME';
      } else if (
        key.includes('last_name') &&
        !values[key] &&
        !values[key]?.replace(/\s/g, '').length
      ) {
        errors[key] = 'VALIDATORS.PATIENT_LAST_NAME';
      } else if (
        key.includes('amount') &&
        isNaN(values[key].replace(/\$/g, '').replace(/,/g, ''))
      ) {
        errors[key] = 'VALIDATORS.PATIENT_AMOUNT';
      } else if (
        key.includes('phone') &&
        !values[key] &&
        !values[key]?.replace(/\s/g, '').length
      ) {
        errors[key] = 'VALIDATORS.PHONE';
      } else if (key.includes('dob') && isNaN(Date.parse(values[key]))) {
        errors[key] = 'VALIDATORS.PATIENT_DOB';
      }
    });
  for (const key of Object.keys(errors)) {
    if (errors[key]) {
      return errors;
    }
  }
  return {};
};
